<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="font-weight-bold">
          Account Delete Request
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6" class="py-0 px-0">
              <v-col sm="12" class="py-0">
                <v-text-field
                  v-model="form.name"
                  outlined
                  label="First Name *"
                  prepend-inner-icon="mdi-buffet"
                  :error-messages="errors.name"
                ></v-text-field>
              </v-col>
              <v-col sm="12" class="py-0">
                <v-text-field
                  v-model="form.phone"
                  outlined
                  label="Enter a phone *"
                  prepend-inner-icon="mdi-buffet"
                  :error-messages="errors.phone"
                ></v-text-field>
              </v-col>
            </v-col>
            <v-col
              sm="6"
              class="py-0 px-0 text-h5 font-weight-bold"
              align="center"
            >
              <v-img
                alt="Vuetify Name"
                class="mt-1"
                contain
                :src="
                  company.logo_path
                    ? `${mediaUrl + company.logo_path}`
                    : require('../../assets/logo1.png')
                "
                width="550"
                height="150"
              />
              Mama Bhanja Apps
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn
            :loading="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Send Request
          </v-btn>
          <v-dialog v-model="SuccessDialog" max-width="370" persistent>
            <v-card>
              <v-card-title class="text-subtitle-1">
                <img src="../../assets/success.gif" width="320" alt="" />
                Delete Account Request Send Successfully
              </v-card-title>
              <v-card-text> </v-card-text>
              <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text @click="dialog = false">
                                    Disagree
                                </v-btn>
                                <v-btn color="green darken-1" text @click="dialog = false">
                                    Agree
                                </v-btn>
                            </v-card-actions> -->
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        soft_password: "123456",
        user_devices: [],
        user_locations: [],
      },
      isLoading: false,
      SuccessDialog: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.form.status = 1;
        await axios.post("/account_delete_request", this.form);
        this.SuccessDialog = true;
        this.isLoading = false;
        this.form = [];
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>
